import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';
import {CommonWrapper} from './LightHomePage.style';
import {isIE11} from '../../helpers/ie.helper';

export const Columns = styled.div`
  display: flex;
  width: 100%;
  margin-top: 4rem;
  ${media.small`
     flex-direction: column;
     padding: 0 2rem;
  `};
`;

export const IconsWrapper = CommonWrapper.extend`
  background-color: ${p => p.theme.secondaryBgColor};
`;

export const Column = styled.div`
  flex-grow: 1;
  flex-basis: 0;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 1.5rem;
  background-color: ${p => p.theme.primaryColor};
  padding: 7rem 1rem 4rem;
  ${media.medium`
    text-align: center;
  `};
  ${media.small`
    margin: 2rem 0 4rem;
    display: block;
  `};
`;

export const IconWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  text-align: center;
`;

export const Icon = styled.div`
  position: absolute;
  top: -6rem;
  width: 8.5rem;
  height: 8.5rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${p => p.theme.iconColor};
  margin: 2.4rem 0;
  transition: all 0.4s ease-in-out;
  &:hover {
    background-color: ${p => p.theme.secondaryColor};
  }

  ${isIE11() && `
    margin-left: -4.25rem
  `}
`;

export const IconEat = styled.img`
  color: ${p => p.theme.primaryColor};
  height: 3.4rem;
`;

export const IconDrink = styled.img`
  color: ${p => p.theme.primaryColor};
  height: 4rem;
`;

export const IconDeliver= styled.img`
  color: ${p => p.theme.primaryColor};
  height: 4.8rem;
`;

export const IconTitle = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-size: 2rem;
  text-transform: uppercase;
  padding-top: 1.4rem;
  padding-bottom: 1.2rem;
`;

export const IconBody = styled.span`
  color: ${p => p.theme.quaternaryColor};
  font-size: 1.8rem;
  line-height: 2.8rem;
  padding: 1rem 1.2rem 0;
  text-align: center;
  width: 100%;
  max-width: 100%;
  flex-basis: 100%;
  ${isIE11() && `
    flex-basis: auto;
  `}
`;



// WEBPACK FOOTER //
// ./containers/LightHomePage/Icons.style.js